/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Kind_CorrectInputs */

const en_us2_offline_kind_correct = /** @type {(inputs: Offline_Kind_CorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set correction`)
};

const pt_br2_offline_kind_correct = /** @type {(inputs: Offline_Kind_CorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correção de série`)
};

const es_419_offline_kind_correct = /** @type {(inputs: Offline_Kind_CorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corrección de serie`)
};

const pt_pt2_offline_kind_correct = /** @type {(inputs: Offline_Kind_CorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correção de série`)
};

const fr_fr2_offline_kind_correct = /** @type {(inputs: Offline_Kind_CorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correction de série`)
};

const de_de2_offline_kind_correct = /** @type {(inputs: Offline_Kind_CorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satzkorrektur`)
};

const it_it2_offline_kind_correct = /** @type {(inputs: Offline_Kind_CorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correzione serie`)
};

/**
* | output |
* | --- |
* | "Set correction" |
*
* @param {Offline_Kind_CorrectInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_kind_correct = /** @type {((inputs?: Offline_Kind_CorrectInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Kind_CorrectInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_kind_correct(inputs)
	if (locale === "es-419") return es_419_offline_kind_correct(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_kind_correct(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_kind_correct(inputs)
	if (locale === "de-DE") return de_de2_offline_kind_correct(inputs)
	if (locale === "it-IT") return it_it2_offline_kind_correct(inputs)
	return en_us2_offline_kind_correct(inputs)
});
export { offline_kind_correct as "offline.kind_correct" }